import { render } from "./FLayout.vue?vue&type=template&id=f722f5fe&scoped=true"
import script from "./FLayout.vue?vue&type=script&lang=js"
export * from "./FLayout.vue?vue&type=script&lang=js"

import "./FLayout.vue?vue&type=style&index=0&id=f722f5fe&lang=less&scoped=true"
import "./FLayout.vue?vue&type=style&index=1&id=f722f5fe&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f722f5fe"]])

export default __exports__